import React from 'react';
import * as Sentry from '@sentry/react';

// A custom fallback component to show when an error occurs
const FallbackComponent = ({ error, componentStack, resetError }) => {
  return (
    <div className="error-boundary">
      <h2>Something went wrong</h2>
      <p>We've been notified about this issue and are working to fix it!</p>
      {process.env.NODE_ENV !== 'production' && (
        <div>
          <h3>Error Details:</h3>
          <p>{error.toString()}</p>
          <h3>Component Stack:</h3>
          <pre>{componentStack}</pre>
        </div>
      )}
      <button onClick={resetError}>Try again</button>
    </div>
  );
};

// Export the Sentry Error Boundary for use in your app
const SentryErrorBoundary = ({ children }) => (
  <Sentry.ErrorBoundary fallback={FallbackComponent}>
    {children}
  </Sentry.ErrorBoundary>
);

export default SentryErrorBoundary;